module.exports = __webpack_public_path__ + "img/a4.af865175.jpg";